import React, { useState } from "react";

const Support = () => {
  const [statement, setStatement] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!statement.trim())
      newErrors.statement = "Statement Heading is required.";
    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is invalid.";
    }
    if (!message.trim()) newErrors.message = "Feedback is required.";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setSubmitted(true);
      setStatement("");
      setEmail("");
      setMessage("");

      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-md-6 bg-white p-5 rounded shadow">
        <h5
          className="mb-3 fw-bold"
          style={{
            background: "linear-gradient(90deg, #A14BFF, #0F81FF)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Okey Doke
        </h5>
        <h2 className="mb-4 text-center fw-bold">Support</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Email Address</label>
            <input
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email}</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Statement Heading</label>
            <input
              type="text"
              className={`form-control ${errors.statement ? "is-invalid" : ""}`}
              placeholder="Enter statement heading"
              value={statement}
              onChange={(e) => setStatement(e.target.value)}
            />
            {errors.statement && (
              <div className="invalid-feedback">{errors.statement}</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Feedback</label>
            <textarea
              className={`form-control ${errors.message ? "is-invalid" : ""}`}
              rows="4"
              placeholder="Enter your message here..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            {errors.message && (
              <div className="invalid-feedback">{errors.message}</div>
            )}
          </div>

          <button
            type="submit"
            className="btn w-100 text-white border-0"
            style={{
              background: "linear-gradient(90deg, #A14BFF, #0F81FF)",
            }}
          >
            Submit
          </button>

          {submitted && (
            <div className="alert alert-success mt-3 text-center">
              Thank you! Your request has been submitted successfully.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Support;
